import { RequestService } from '../../../../../common/services/RequestService';
import { VEHICLE_TYPES } from '../../constants';

export const getVehicleTypesRequest = payload => {
  return RequestService.get(VEHICLE_TYPES);
};
